import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useLanguage } from '../../../contexts/LanguageContext';

const ExportPanel = ({ onExportPDF, onExportCSV }) => {
  const [exporting, setExporting] = useState(false);
  const { t, currentLanguage } = useLanguage();

  const handleExport = async (type) => {
    setExporting(true);
    try {
      if (type === 'pdf') {
        await onExportPDF();
      } else {
        await onExportCSV();
      }
    } catch (error) {
      console.error('Export error:', error);
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-warm p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4">
        <Icon name="Download" size={20} className="text-primary" />
        <h3 className="text-sm sm:text-base font-semibold text-foreground">
          {t('common.export')}
        </h3>
      </div>
      <div className="space-y-3">
        <Button
          variant="outline"
          iconName="FileText"
          iconPosition="left"
          onClick={() => handleExport('pdf')}
          disabled={exporting}
          fullWidth
          className="justify-center"
        >
          <span className="text-xs sm:text-sm font-medium">
            {exporting ? t('analytics.exporting') : t('analytics.exportPDF')}
          </span>
        </Button>
        <Button
          variant="outline"
          iconName="Table"
          iconPosition="left"
          onClick={() => handleExport('csv')}
          disabled={exporting}
          fullWidth
          className="justify-center"
        >
          <span className="text-xs sm:text-sm font-medium">
            {exporting ? t('analytics.exporting') : t('analytics.exportCSV')}
          </span>
        </Button>
      </div>
    </div>
  );
};

export default ExportPanel;